var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { gql, useApolloClient, useMutation } from '@apollo/client';
import { useLocation } from '../../../hooks';
import { DateTime } from 'luxon';
import { METRIC_NAME, logger } from '@amzn/atoz-shiftapp-metrics';
import { getSwapRequestsForDayFromMap, useAssociateContext, BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { ShiftFlowModalContentTypes } from '../ShiftFlowModalTypes';
import { getSwapsRefetchQuery, pendingSwapRequestsToDaysMap as generatePendingSwapRequestsToDaysMap } from '../../../utils';
export var useCancelSwapRequestModalContentData = function (_a) {
    var setModalContent = _a.setModalContent, setModalError = _a.setModalError, scheduleShift = _a.scheduleShift, siteSwapConfiguration = _a.siteSwapConfiguration, swapRequests = _a.swapRequests;
    var client = useApolloClient();
    var pathname = useLocation().pathname;
    var _b = React.useState(false), hasErrors = _b[0], setHasErrors = _b[1];
    var _c = React.useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = React.useState(false), isSuccessful = _d[0], setIsSuccessful = _d[1];
    var associateInfo = useAssociateContext().associateInfo;
    var _e = siteSwapConfiguration || {}, swapEnabled = _e.swapEnabled, siteId = _e.siteId;
    var pendingSwapRequestsToDaysMap = generatePendingSwapRequestsToDaysMap(swapRequests === null || swapRequests === void 0 ? void 0 : swapRequests.swaps);
    var onCancelSwapRequest = useMutation(CANCEL_SWAP_REQUEST_MUTATION)[0];
    React.useEffect(function () {
        if (hasErrors) {
            setModalContent(ShiftFlowModalContentTypes.swapCancelError);
        }
    }, [hasErrors, setModalContent]);
    React.useEffect(function () {
        if (isSuccessful) {
            client.refetchQueries({
                include: getSwapsRefetchQuery(pathname)
            });
            setModalContent(ShiftFlowModalContentTypes.swapCancelSuccess);
        }
    }, [client, isSuccessful, pathname, setModalContent]);
    var shiftStartDateTime = React.useMemo(function () { return DateTime.fromISO(scheduleShift.shift.timeRange.start); }, [scheduleShift.shift.timeRange.start]);
    var _f = React.useMemo(function () {
        if (!swapEnabled || !swapRequests) {
            return {
                pendingSwapIdsForDay: [],
                pendingSwapRequestShifts: []
            };
        }
        var pendingSwapsForDay = getSwapRequestsForDayFromMap(pendingSwapRequestsToDaysMap, shiftStartDateTime);
        var pendingSwapRequestShifts = !!(pendingSwapsForDay === null || pendingSwapsForDay === void 0 ? void 0 : pendingSwapsForDay.length)
            ? pendingSwapsForDay[0].from.shifts
            : [];
        return {
            pendingSwapIdsForDay: pendingSwapsForDay.map(function (swap) { return swap.id; }),
            pendingSwapRequestShifts: pendingSwapRequestShifts
        };
    }, [
        swapEnabled,
        swapRequests,
        pendingSwapRequestsToDaysMap,
        shiftStartDateTime
    ]), pendingSwapIdsForDay = _f.pendingSwapIdsForDay, pendingSwapRequestShifts = _f.pendingSwapRequestShifts;
    var swapFromDate = React.useMemo(function () {
        if (!pendingSwapIdsForDay.length || !pendingSwapRequestShifts.length) {
            logger.emitCountMetric({
                metricName: METRIC_NAME.DATA_ERROR_SWAP_SHIFTS_FOR_DAY_EMPTY,
                dimensions: {}
            });
            logger.error('useCancelSwapRequestModalContent received an empty swapRequests');
            return null;
        }
        var dateOfShifts = DateTime.fromISO(pendingSwapRequestShifts[0].timeRange.start);
        return dateOfShifts.toLocaleString({
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    }, [pendingSwapIdsForDay, pendingSwapRequestShifts]);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!siteId)
                        return [2 /*return*/];
                    BIAnalytics.cancelSwap(pendingSwapIdsForDay, associateInfo.employeeId, siteId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, Promise.all(pendingSwapIdsForDay.map(function (swapRequestId) {
                            var cancelSwapRequestInput = {
                                siteId: siteId,
                                swapRequestId: swapRequestId
                            };
                            return onCancelSwapRequest({
                                variables: { cancelSwapRequestInput: cancelSwapRequestInput }
                            });
                        }))];
                case 2:
                    _a.sent();
                    client.refetchQueries({
                        include: getSwapsRefetchQuery(pathname)
                    });
                    BIAnalytics.cancelSwapSuccess(pendingSwapIdsForDay, associateInfo.employeeId, siteId);
                    setIsSuccessful(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    logger.emitError('Issue cancelling swap request', {
                        error: new Error(error_1)
                    });
                    BIAnalytics.cancelSwapFailure(pendingSwapIdsForDay, associateInfo.employeeId, siteId);
                    setModalError(error_1);
                    setHasErrors(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        siteId: siteId || null,
        swapFromDate: swapFromDate,
        pendingSwapRequestShifts: pendingSwapRequestShifts
    };
};
export var CANCEL_SWAP_REQUEST_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation CancelSwapRequest(\n        $cancelSwapRequestInput: CancelSwapRequestInput!\n    ) {\n        cancelSwapRequest(input: $cancelSwapRequestInput)\n    }\n"], ["\n    mutation CancelSwapRequest(\n        $cancelSwapRequestInput: CancelSwapRequestInput!\n    ) {\n        cancelSwapRequest(input: $cancelSwapRequestInput)\n    }\n"])));
useCancelSwapRequestModalContentData.fragments = {
    scheduleShift: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment UseCancelSwapRequestModalContentData_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n            }\n        }\n    "], ["\n        fragment UseCancelSwapRequestModalContentData_ScheduleShift on ScheduleShift {\n            shift {\n                timeRange {\n                    start\n                    end\n                }\n            }\n        }\n    "]))),
    siteSwapConfiguration: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        fragment UseCancelSwapRequestModalContentData_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n            swapEnabled\n        }\n    "], ["\n        fragment UseCancelSwapRequestModalContentData_SiteSwapConfiguration on SiteSwapConfiguration {\n            siteId\n            swapEnabled\n        }\n    "]))),
    swapRequests: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        fragment UseCancelSwapRequestModalContentData_SwapRequests on SwapRequests {\n            swaps {\n                from {\n                    shifts {\n                        timeRange {\n                            start\n                            end\n                        }\n                    }\n                }\n                id\n                status\n                to {\n                    shifts {\n                        timeRange {\n                            start\n                            end\n                        }\n                    }\n                }\n            }\n        }\n    "], ["\n        fragment UseCancelSwapRequestModalContentData_SwapRequests on SwapRequests {\n            swaps {\n                from {\n                    shifts {\n                        timeRange {\n                            start\n                            end\n                        }\n                    }\n                }\n                id\n                status\n                to {\n                    shifts {\n                        timeRange {\n                            start\n                            end\n                        }\n                    }\n                }\n            }\n        }\n    "])))
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
